import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on every route change.
 * Also forces an iOS Safari repaint to fix the "visuals only appear
 * after interaction" issue caused by Safari's bfcache / compositing quirks.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset scroll position
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      // Fallback for browsers that don't support 'instant'
      window.scrollTo(0, 0);
    }

    // Force iOS Safari repaint: briefly toggle a harmless style on <body>
    // to flush its compositing layer after navigation.
    const { body } = document;
    body.style.webkitTransform = 'translateZ(0)';
    const rafId = requestAnimationFrame(() => {
      body.style.webkitTransform = '';
    });

    return () => cancelAnimationFrame(rafId);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
